import { z } from "zod/v4";
import { paginationSearchSchema } from "#/modules/util.pagination/search.pagination";
import type { components } from "#/schema";

const sortOrder = ["ascending", "descending"] as const;

/**
 * Search params schema for students overview: searchTerm, orderBy, orderDirection, klasId (optional), pagination.
 */
export const studentsSearchSchema = paginationSearchSchema.extend({
  searchTerm: z.string().default(""),
  orderBy: z
    .string()
    .default("name" satisfies keyof components["schemas"]["LeerlingOverviewModel"]),
  orderDirection: z.enum(sortOrder).default("ascending").catch("ascending"),
  klasId: z.string().nullable().default(null),
});

/** Default values for students search params; values not explicitly set will be omitted from URL. */
export const STUDENTS_SEARCH_DEFAULTS = {
  searchTerm: "",
  orderBy: "name",
  orderDirection: "ascending" as const,
  klasId: null,
  page: 1,
  pageSize: 40,
};

export type StudentsSearch = z.infer<typeof studentsSearchSchema>;
